import { version } from '../../package.json';

(function (w, d) {
  var currentFile = document.getElementById('webchat-script');
  var webchatParams = JSON.parse(
    currentFile.getAttribute('data-webchat-params'),
  );
  var kvp_value = webchatParams.KVP;

  var webchatBaseUrl = process.env.WEBCHAT_BASE_URL;
  var options = {
    brand: 'CMG Apply',
    locale: d.documentElement.lang,
    deploymentID: process.env.WEBCHAT_DEPLOYMENT_ID + '-' + version,
    assetsPath: webchatBaseUrl + '/',
    theme: 'gds',
    debug: {
      genesys: process.env.GENESYS_DEBUG === 'true',
      plugins: process.env.WEBCHAT_DEBUG === 'true',
    },
    cookies: {
      domain: process.env.WEBCHAT_COOKIE_DOMAIN,
      expires: process.env.WEBCHAT_COOKIE_EXPIRES,
      path: process.env.WEBCHAT_COOKIE_PATH,
      secure: process.env.WEBCHAT_COOKIE_SECURE === 'true',
      sameSite: 'Strict',
    },
    webchat: {
      mode: 'toast',
      mobile: {
        mode: 'auto',
        breakpoint: 600,
      },
      userData: {
        KV_CMS_CHATTYPE: kvp_value,
      },
      defaultLocale: 'en',
      maxMessageLength: 500,
      dataUrl: process.env.WEBCHAT_DATA_URL,
      popup: {
        path: process.env.BASE_PATH + process.env.WEBCHAT_POPUP_PATH,
      },
    },
    plugins: {
      WebChatTerms: {
        disabled: true,
      },
      WebChatScheduler: {
        schedule: [
          {
            dayNo: 1,
            open: process.env.WEBCHAT_MON_OPENING_TIME,
            close: process.env.WEBCHAT_MON_CLOSING_TIME,
          },
          {
            dayNo: 2,
            open: process.env.WEBCHAT_TUE_OPENING_TIME,
            close: process.env.WEBCHAT_TUE_CLOSING_TIME,
          },
          {
            dayNo: 3,
            open: process.env.WEBCHAT_WED_OPENING_TIME,
            close: process.env.WEBCHAT_WED_CLOSING_TIME,
          },
          {
            dayNo: 4,
            open: process.env.WEBCHAT_THU_OPENING_TIME,
            close: process.env.WEBCHAT_THU_CLOSING_TIME,
          },
          {
            dayNo: 5,
            open: process.env.WEBCHAT_FRI_OPENING_TIME,
            close: process.env.WEBCHAT_FRI_CLOSING_TIME,
          },
          {
            dayNo: 6,
            open: process.env.WEBCHAT_SAT_OPENING_TIME,
            close: process.env.WEBCHAT_SAT_CLOSING_TIME,
          },
        ],
      },
      WebChatOI: {
        analytics: {
          url: process.env.WEBCHAT_ANALYTICS_URL,
        },
      },
      WebChatSurvey: {
        ratings: {
          type: 'radio',
          choices: [
            {
              value: 1,
              label: 'Yes',
              options: [],
            },
            {
              value: 0,
              label: 'No',
              options: [
                {
                  value: 200,
                  label: 'I was advised to call',
                },
                {
                  value: 201,
                  label: "Didn't have enough time",
                },
                {
                  value: 202,
                  label: 'Agent was unable to see my details',
                },
                {
                  value: 203,
                  label: 'Chat disconnected',
                },
                {
                  value: 204,
                  label: 'Chat timed out',
                },
              ],
            },
          ],
        },
      },
    },
  };

  (function (d) {
    var s = d.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = options.assetsPath + 'app.js?' + version;
    s.setAttribute('data-options', JSON.stringify(options));
    var x = d.getElementsByTagName('script')[0];
    x.parentNode.insertBefore(s, x);
  })(d);
})(window, document);
